<template>
<div class="scroll-wrap">
  <ul class="scroll-content" :style="{ top, transition}">
        <li v-for="reward in rewardList">{{reward.mobile}}&nbsp;获得推荐奖励{{reward.amount}}元</li>
   </ul>
</div>
</template>
<style>
.scroll-wrap{
  display: inline-block;
  height: 1rem;
  overflow: hidden;
}

.scroll-content{
  line-height: 1rem;
  position: relative;
  transition: top 0.5s;
}
</style>
<script>
export default {
  name: 'RewardScroll',
  props: ['rewardList'],
  data () {
    return {
      rewardIndex: 0
    }
  },
  computed: {
    top () {
      return -this.rewardIndex * 1 + 'rem'
    },
    transition () {
      return this.rewardIndex === 0 ? 'none' : 'top 0.5s'
    }
  },
  methods: {

  },
  mounted: function () {
    setInterval(_ => {
      if (this.rewardIndex < this.rewardList.length - 1) {
        this.rewardIndex += 1
      } else {
        this.rewardIndex = 0
      }
    }, 2000)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reward-scroll.vue